import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Table } from '@itds/elements/index.js';

import EditProductDrawer from './Edit';

import { Api } from '@brokerage/utils/Api';

const CarrierProductsList = () => {
  const params = useParams();

  const [carrier_products, setCarrierProducts] = useState([]);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = () => {
    Api.loadCarrierSpecificProducts(params.carrier_id).then(response => {
      setCarrierProducts(response.data);
    });
  };

  const handleDelete = (id, e) => {
    e.stopPropagation();

    window.scrollTo(0, 0);

    Api.deleteCarrierProduct(id).then(() => {
      loadProducts();
    });
  };

  const handleSave = () => {
    setProduct(null);
    loadProducts();
  };

  return (
    <>
      <EditProductDrawer
        onClose={setProduct.bind(null, null)}
        onSave={handleSave}
        product={product}
        show={!!product}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button inline={true} onClick={setProduct.bind(null, { carrier_id: params.carrier_id })}>
          New Product
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name'
          },
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'actions',
            render: row => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, row.id)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={carrier_products}
        onRowClick={setProduct}
      />
    </>
  );
};

CarrierProductsList.propTypes = {
  carrier: PropTypes.object
};

export default CarrierProductsList;
